export default {
    getBudget: (state) => state.payload.PriceTo,
    getMinMax: (state) =>{
        return {
            min:state.price.min,
            max:state.price.max
        }
    } ,
    getShape: (state) => state.payload.Shape,
    getPrioritySize: (state) => state.payload.Sort,
    getPriorityColor: (state) => state.payload.Color,
    getPriorityClarity: (state) => state.payload.Clarity,
    getResult: (state) => state.result,
    getPayload:(state) =>  state.payload

}
